// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"308f6a21","139":"f42e0064","272":"7d979f41","473":"b8b08474","683":"84f3738b","754":"e9f29d13","963":"4859e7a1","964":"7d784f99"}[chunkId] + ".chunk.js";
};